<template>
	<personal-layout cur-menu="tradelistomni">
		<div class="right-box">
			<div class="flex-row back-box">
				<i class="el-icon-arrow-left back-btn" @click="goBack"></i>
				<div class="title">订单明细</div>
			</div>
			<div class="status-box">
				<div>
					<div class="trade-status" v-if="tradeDetail.tradeStatus == '5020'">销售单状态：原始单-被合并
					</div>
					<div class="trade-status" v-else-if="tradeDetail.tradeStatus == '5030'">销售单状态：原始单-被拆分
					</div>
					<div class="trade-status" v-else>
						销售单状态：{{ !!tradeDetail.tradeStatusExplain && tradeDetail.tradeStatusExplain.indexOf('代销发货') >= 0 ? '待发货'
							: tradeDetail.tradeStatusExplain }}
					</div>
					<div class="trade-status" v-if="sellbackInfo.sellbackStatusExplain">
						售后单状态：{{ sellbackInfo.sellbackStatusExplain }}</div>
				</div>

				<div class="trade-log flex-row" v-show="isShowTrailInfo" @click="showTradeLog">
					<div class="simple-info" v-show="false"> {{ simpleTrailInfo }}</div>
					<div class="log-btn">物流轨迹</div>
				</div>
			</div>
			<div class="info-box" v-if="tradeDetail.logisticType == '1' || tradeDetail.logisticType == '3'">
				<div class="small-title">收件人信息</div>
				<div class="base-info">
					<div><span class="base-item">姓名：</span><span>{{ tradeReceiver.receiverName }}</span></div>
					<div><span class="base-item">电话：</span><span>{{ tradeReceiver.mobile }}</span></div>
					<div><span class="base-item">地址：</span><span v-if="tradeReceiver.province">{{ tradeReceiver.province
					}}&nbsp;</span><span v-if="tradeReceiver.city">{{ tradeReceiver.city }}&nbsp;</span><span v-if="tradeReceiver.town">{{ tradeReceiver.town }}&nbsp;</span><span v-if="tradeReceiver.district">{{
								tradeReceiver.district }}&nbsp;</span><span v-if="tradeReceiver.country != '中国'">{{ tradeReceiver.country
							}}&nbsp;</span><span v-if="tradeReceiver.address">{{ tradeReceiver.address }}</span></div>
				</div>
				<!-- <div class="address-editbtn" @click="openAddressEdit"
					v-if="tradeDetail.isAllowEditTradeAddress && config.isAllowEditTradeAddress">修改地址</div> -->
			</div>
			<div class="info-box" v-else-if="tradeDetail.logisticType == '2'">
				<div class="small-title">自提信息</div>
				<div class="base-info">
					<div><span class="base-item">自提点：</span><span>{{ tradeDetail.channelAnotherName }}</span></div>
					<div><span class="base-item">地 点：</span><span>{{ tradeReceiver.address }}</span></div>
					<div><span class="base-item">自提人：</span><span>{{ tradeReceiver.receiverName }} &nbsp;
							{{ $utils.regTel(tradeReceiver.mobile) }}</span></div>
				</div>
			</div>
			<div class="info-box">
				<div class="small-title">订单信息</div>
				<div class="base-info">
					<el-row :gutter="20">
						<el-col :span="tradeDetail.logisticType != '2' ? 12 : 24">
							<div><span class="base-item">交易时间：</span><span>{{ tradeDetail.tradeTime }}</span></div>
							<div><span class="base-item">订单编号：</span><span>{{ tradeDetail.tradeNo }}</span><span v-show="tradeDetail.tradeNo" class="copy-btn" v-clipboard:copy="tradeDetail.tradeNo" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></div>
							<div><span class="base-item">原始单号：</span><span>{{ tradeDetail.sourceTradeNo }}</span><span v-show="tradeDetail.sourceTradeNo" class="copy-btn" v-clipboard:copy="tradeDetail.sourceTradeNo" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></div>
						</el-col>
						<el-col :span="12" v-show="tradeDetail.logisticType != '2'">
							<div><span class="base-item">物流公司：</span><span>{{ tradeDetail.logisticName || "" }}</span></div>
							<div><span class="base-item">物流单号：</span><span>{{ tradeDetail.mainPostid || "" }}</span></div>
							<div class="flex-row">
								<div class="base-item">备注：</div>
								<div>{{ tradeDetail.buyerMemo }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="info-box">
				<div class="small-title">商品清单</div>
				<goods-list :isShowSingleSpec="isShowSingleSpec" :goodslist="tradeGoods"></goods-list>
			</div>
			<div class="info-box total-box">
				<el-form label-position="right" label-width="100px" class="flex-col">
					<el-form-item label="商品总数 :">
						<div class="money-text">x {{ $utils.amountFixed(tradeDetail.tradeCount, 0) }}</div>
					</el-form-item>
					<el-form-item label="优    惠 :" v-if="tradeDetail.discountFee > 0">
						<div class="money-text">
							{{ $currency.symbol }}{{ $utils.amountFixed(tradeDetail.discountFee, 2) }}
						</div>
					</el-form-item>
					<el-form-item label="运    费 :">
						<div class="money-text">
							{{ $currency.symbol }}{{ $utils.amountFixed(tradeDetail.receivedPostFee, 2) }}
						</div>
					</el-form-item>
					<el-form-item label="货品积分 :" v-if="tradeDetail.goodsScoreTotal > 0">
						<div class="money-text">
							{{ tradeDetail.goodsScoreTotal }}积分
						</div>
					</el-form-item>
					<el-form-item label="抵扣积分 :" v-if="tradeDetail.deductionScoreTotal > 0">
						<div class="money-text">
							{{ tradeDetail.deductionScoreTotal }}积分
						</div>
					</el-form-item>
					<el-form-item label="订单共计 :">
						<div class="money-text total">
							<span v-show="tradeDetail.payment > 0 || tradeDetail.pointTotal == 0">{{ $currency.symbol }}{{
								$utils.amountFixed(tradeDetail.payment,
									2) }}</span>
							<span v-show="tradeDetail.payment != 0 && tradeDetail.pointTotal > 0"> + </span>
							<span v-show="tradeDetail.pointTotal > 0">{{ tradeDetail.pointTotal }}</span>
							<span v-show="tradeDetail.pointTotal > 0" class="score-text">积分</span>
						</div>
					</el-form-item>

				</el-form>
			</div>
		</div>
		<div class="dialogBox">
			<el-dialog class="detailDialog" title="查看轨迹" :visible.sync="trajectoryShow" style="margin-left: 28%;width:880px;overflow: hidden;">
				<iframe :src="webviewSrc" style="border: none; width: 402px; height: 628px;"></iframe>
			</el-dialog>
		</div>

		<address-edit v-if="showEditDialog" :addressinfo="currentAddr" :isFromTradeDetail="true" title="修改地址" :isCreate="createEditDialog" :isShow="showEditDialog" @close="closeEditDialog" @success="editSuccess"></address-edit>
		<trade-logistic :isShow="showLogDialog" :tradeId="tradeDetail.tradeId" :tradeNo="tradeDetail.tradeNo" :logisticId="tradeDetail.logisticId" :logisticNo="tradeDetail.logisticNo" :mobile="tradeReceiver.mobile" @hastrailinfo="hasTrailInfo" @close="closeLogDialog"></trade-logistic>
	</personal-layout>

</template>

<script>
	import '../../theme/element/theme/self.css';
	import _ from 'lodash';
	import personalLayout from '../../components/mine/PersonalLayout.vue';
	import goodsList from '../../components/trade/GoodsListJmc.vue';
	import tradeLogistic from '../../components/trade/TradeLogistic.vue';
	import commonUtils from '../../utils/common-utlis.js';
	import tradeApi from '../../utils/api-utils/api-trade.js';
	import refundApi from '../../utils/api-utils/api-refund.js';
	import addressApi from '../../utils/api-utils/api-address.js';
	import {
		getCustomerInfo
	} from '../../utils/api-utils/api-customer.js';
	import {
		getParam
	} from '../../utils/api-utils/api-params.js';
	import {
		callFeign
	} from '../../utils/api-utils/api-callFeign.js';
	import {
		addJackyunLog
	} from '../../utils/api-utils/api-jackyunlog.js';
	import {
		system
	} from '../../utils/api-utils/api-sys.js';
	import addressEdit from '../../components/trade/AddressEdit.vue';
	export default {
		name: 'tradedetail',
		components: {
			personalLayout,
			goodsList,
			tradeLogistic,
			addressEdit
		},

	data() {
		const validateMoney = (rule, val, callback) => {
			let that = this;
			if (val.length == 0) {
				callback("请输入退款金额");
			}
			let num = val.toString(); //先转换成字符串类型
			if (num.indexOf('.') == 0) { //第一位就是 .
				num = '0' + num;
			}
			num = num.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (num.indexOf(".") < 0 && num != "") {
				num = parseFloat(num);
			}
			if (num > that.maxReturnAmount) {
				num = that.maxReturnAmount;
			}
			that.refundLogistics.sellBackApplyAmount = num;
			callback();
		};
		return {
			tradeNo: "", //this.$route.params.tradeNo, //接收上一个页面的传值
			tradeDetail: {},
			tradeReceiver: {},
			jmallTradeDetail: {},
			tradeGoods: [],
			statusText: ['已取消', '待付款', '待审核', '待发货', '已发货', '已完成', '', '', '', '退款中', '退款完成', '', '', '', '退货中',
				'退货完成'
			],
			isShowTrailInfo: false, //是否有订单轨迹相关信息
			simpleTrailInfo: '', //简易物流信息
			showLogDialog: false, //是否展示物流轨迹	
			dialogVisible: false, //退款弹窗
			isShowReturnGoodsDialog: false, //退货弹窗
			isShowReturnMainDialog: false, //退货物流信息弹窗
			refundResonList: ["拍错/多拍", "不想要了", "订单信息有误", "其他"],
			refundForm: {
				reson: '',
				remark: '',
			},
			customer: {}, //顾客信息
			isSelectAllReturnGoods: false, // 全选
			refundGoodsSelection: [], //选中退货商品信息
			isIndeterminate: false, // 全选确定状态
			sumCount: 0, //退货数量
			sumScore: 0, //退货积分
			//退货物流信息
			refundLogistics: {
				logisticId: '',
				logisticName: '',
				rcv_post_id: '',
				reason: '卖家发错货',
				remark: '',
				sellBackApplyAmount: ''
			},
			logisticsWays: [], // 物流方式
			refundGoodsReson: ["卖家发错货", "做工问题", "描述不符", "其他"], //退货原因
			refundGoodsRules: {
				postId: [{
					required: true,
					message: '请输入物流单号',
					trigger: 'blur'
				}],
				refundReason: [{
					required: true,
					message: '请选择退货原因',
					trigger: 'change'
				}],
				sellBackApplyAmount: [{
					required: true,
					trigger: 'change',
					validator: validateMoney

					}]
				},
				subTradeList: [],
				sellbackStatus: '', //退款状态
				sellbackType: '', // 退款类型
				isClickRefund: true, // 退款/退货按钮显示/不显示
				reFundList: [], // 退货数据列表\
				isShowSingleSpec: true, // 是否展示单规格
				logisticName: "", // 订单物流名称
				trajectoryShow: false,
				webviewSrc: "",
				config: {
					isOpenCannotReturnTime: false,
					cannotReturnDays: 0
				},
				returnPlaceHolder: "",
				omsTradeInfo: {}, // 原始销售单信息
				originalTradeList: [], // 原始单列表
				originalTradeGoodsList: [], // 原始单商品列表（多个订单的货品合并到一起，并附加一些订单信息到商品上）
				sellbackInfo: {}, // 当前订单的退款信息
				canReturnGoodsList: [], // 可退货商品列表
				selectedReturnGoodsList: [], // 选中的退货商品列表
				maxReturnAmount: 0, // 最大可退金额
				currentAddr: {},
				createEditDialog: false,
				showEditDialog: false,
				sellBackAddressInfo: {},
				isOpenShowSellBackAddress: false,
				ticketIds: [], // ticketId集合,退款退货使用
				hasEleTicket: false, // 是否含电子票订单
			};
		},
		created() {
			// 默认绑定退款原因(拍错/多拍)
			this.refundForm.reson = this.refundResonList[0];
		},
		async mounted() {
			// 接收参数	
			await this._getParams();

			// 获取订单详情
			await this._getTradeDetail();
		},
		methods: {
			hasTrailInfo(hasInfo, info) {
				this.isShowTrailInfo = hasInfo;
				this.simpleTrailInfo = info;
			},
			showTradeLog() {
				this.showLogDialog = true;
			},
			closeLogDialog() {
				this.showLogDialog = false;
			},
			//获取吉客云订单明细
			async _getTradeDetail() {
				let omsTradeInfo = await tradeApi.getOmsTradeDetail(this.tradeNo);

				if (!omsTradeInfo.tradeId) {
					this.$message.error({
						message: '订单不存在'
					});
					commonUtils.backPage();
				}

				// 地址信息
				this._setAddressInfo(omsTradeInfo);


				let tradeDetail = omsTradeInfo.tradeOrder; //订单信息
				tradeDetail.mainPostid = (tradeDetail.mainPostid || "") + (omsTradeInfo
					.extraLogisticNo ? ("," + omsTradeInfo.extraLogisticNo || "") : "");
				tradeDetail.extraLogisticNo = omsTradeInfo.extraLogisticNo;
				// 订单状态说明
				tradeDetail.tradeStatusExplain = tradeDetail.tradeStatusExplain.split('-')[0];
				tradeDetail.tradeOrderPayArr = omsTradeInfo.tradeOrderPayArr; // 支付金额信息
				tradeDetail.tradeOrderPayArr.forEach(item => {
					item.payment = item.payment.toFixed(2);
				});

				let tradeGoods = omsTradeInfo.tradeOrderGoodsArr; //货品信息
				let tradeReceiver = omsTradeInfo.tradeOrderReceiver; //收件信息

				// 物流方式
				let logisticId = omsTradeInfo.tradeOrder.logisticId;
				let logisticName = omsTradeInfo.tradeOrder.logisticName;
				this.__getLogisticByLogisticId(logisticId, logisticName);

				// 订单解密
				await tradeApi.tradeDecrypt(omsTradeInfo);

				//格式化订单总价
				tradeDetail.payment = parseFloat(tradeDetail.payment).toFixed(2);
				//重新封装货品信息
				for (let i = 0; i < tradeGoods.length; i++) {
					//提取货品图片
					if (tradeGoods[i].skuImgUrl) {
						let picInfo = JSON.parse(tradeGoods[i].skuImgUrl);
						tradeGoods[i].pic400 = picInfo.pic400x400;
						tradeGoods[i].pic50 = picInfo.pic50x50;
						tradeGoods[i].pic0 = tradeGoods[i].pic0 || picInfo.pic0x0;
					} else {
						tradeGoods[i].pic400 = '/Images/MobileUse/default.png';
						tradeGoods[i].pic0 = tradeGoods[i].pic0 || '/Images/MobileUse/default.png';
					}
					tradeGoods[i].picUrl = tradeGoods[i].sourcePicUrl || tradeGoods[i].pic0;
					//格式化货品单价
					// tradeGoods[i].sellPrice = parseFloat(tradeGoods[i].sellPrice).toFixed(2);
					//格式化货品总价
					tradeGoods[i].sellTotal = parseFloat(tradeGoods[i].sellTotal).toFixed(2);
				}
				if (this.config.channelAnotherNameList) {
					let matchObj = this.config.channelAnotherNameList.find((anotherNameItem) => tradeDetail.logisticId == anotherNameItem.channelId);
					let logisticName = matchObj && matchObj.channelAnotherName;
					tradeDetail.channelAnotherName = logisticName || tradeDetail.logisticName;
				}

				//渲染订单详情界面			       
				this.tradeDetail = tradeDetail;
				this.tradeReceiver = tradeReceiver;
				this.tradeGoods = tradeGoods;
				//获取商城商品图片
				this.webviewSrc = "https://m.kuaidi100.com/result.jsp?nu=" + tradeDetail.mainPostid;
				this.omsTradeInfo = omsTradeInfo;
			},

			/**
			 * 设置地址信息
			 */
			async _setAddressInfo(omsTradeInfo) {
				let tradeOrderReceiver = omsTradeInfo.tradeOrderReceiver;
				let addressInfo = await addressApi.addressrAnalyze(tradeOrderReceiver.address.replace(/\s*/g, ""));
				this.currentAddr = {
					name: tradeOrderReceiver.receiverName,
					tel: tradeOrderReceiver.mobile,
					province: tradeOrderReceiver.state,
					city: tradeOrderReceiver.city,
					district: tradeOrderReceiver.district,
					town: tradeOrderReceiver.town,
					address: addressInfo.address,
					country: tradeOrderReceiver.country,
					zipCode: tradeOrderReceiver.zip,
				};
			},

			/**
			 * 将oms商品列表和原始商品匹配
			 * @param {*} omsTradeInfo 
			 * @param {*} originalTradeGoodsList 
			 */
			_matchOriginalTradeGoodsList(omsTradeInfo, originalTradeGoodsList) {
				// 遍历销售单货品列表，生成退款货品列表（和网店信息通过subTradeId关联）
				let newTradeOrderGoodsArr = [];
				let goodsScoreTotal = 0; // 记录商品购买使用积分总和
				let deductionScoreTotal = 0; // 记录积分抵扣使用积分总和
				omsTradeInfo.tradeOrderGoodsArr.forEach(omsTradeGoods => {
					// 用于标记是否匹配到原始单商品
					let isMatchedGoods = false;
					// 筛选出退款货品关联的原始单货品数据
					let curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.tradeNo == omsTradeGoods.sourceTradeNo &&
						sourceGoods.goodsId == omsTradeGoods.goodsId && sourceGoods.specId == omsTradeGoods.specId && sourceGoods.unit == omsTradeGoods.unit);
					// 标记是否匹配到货品，没有匹配到则按照子单号匹配（不能一开始就用子单号，否则无法区分OMS改单情况，OMS改单后展示数据仍需用销售单的）
					if (curSourceGoodsList.length > 0) {
						isMatchedGoods = true;
					}
					// 仅匹配非组合装情况（组合装子件修改后就无法按照原品比例匹配，所以此处先不处理组合装）
					else if (!omsTradeGoods.fitSubTradeId) {
						curSourceGoodsList = originalTradeGoodsList.filter(sourceGoods => sourceGoods.subTradeNo == omsTradeGoods.sourceSubTradeNo);
					}

					// 补一条当前不在原始单情况的补齐数据
					curSourceGoodsList.push({
						goodsId: omsTradeGoods.goodsId,
						specId: omsTradeGoods.skuId,
						unit: omsTradeGoods.unit,
						tradeId: 0,
						tradeNo: "",
						sellScore: 0,
						sellCount: 99999999,
						singleGoodsDeductionScore: 0
					});

					// 剩余待退货品数量
					omsTradeGoods.remainingCount = omsTradeGoods.sellCount;

					// 将退款货品分配到原始单上（原始单没有的则不需要处理）
					curSourceGoodsList.forEach(sourceGoods => {
						if (omsTradeGoods.remainingCount > 0) {
							// 计算退货数量
							let sellCount = 0;
							if (omsTradeGoods.remainingCount <= sourceGoods.sellCount) {
								sellCount = omsTradeGoods.remainingCount;
								omsTradeGoods.remainingCount = 0;
							} else {
								sellCount = sourceGoods.sellCount;
								omsTradeGoods.remainingCount -= sourceGoods.sellCount;
							}
							// 补充原始商品上的下单信息
							if (isMatchedGoods) {
								omsTradeGoods.sourcePicUrl = sourceGoods.picUrl;
								omsTradeGoods.specName = omsTradeGoods.skuName = sourceGoods.specName || omsTradeGoods.skuName;
								omsTradeGoods.goodsName = sourceGoods.goodsName || omsTradeGoods.goodsName;
								omsTradeGoods.goodsNo = sourceGoods.goodsNo || omsTradeGoods.goodsNo;
								omsTradeGoods.packageGoodsId = sourceGoods.packageGoodsId;
								omsTradeGoods.packageSpecId = sourceGoods.packageSpecId;
								omsTradeGoods.actType = sourceGoods.actType;
								omsTradeGoods.actId = sourceGoods.actId;
							}

							// 复制当前OMS货品信息
							let newOrderGoodsItem = JSON.parse(JSON.stringify(omsTradeGoods));

							// 重新计算当前商品所用积分
							newOrderGoodsItem.sellPoint = sourceGoods.sellScore; // 单个商品购买所需积分
							newOrderGoodsItem.sellCount = sellCount;

							// 统计积分总和
							goodsScoreTotal += newOrderGoodsItem.sellPoint * sellCount;
							deductionScoreTotal += sourceGoods.singleGoodsDeductionScore * sellCount;

							// 生成退货货品
							newTradeOrderGoodsArr.push(newOrderGoodsItem);
						}
					});
				});

				// 记录积分总和
				omsTradeInfo.tradeOrder.goodsScoreTotal = goodsScoreTotal;
				omsTradeInfo.tradeOrder.deductionScoreTotal = parseInt(deductionScoreTotal.toFixed(0));
				omsTradeInfo.tradeOrder.pointTotal = goodsScoreTotal + omsTradeInfo.tradeOrder.deductionScoreTotal;

				omsTradeInfo.newTradeOrderGoodsArr = newTradeOrderGoodsArr;
			},

			/**
			 * 根据吉客云订单状态，生成允许退款/退货的类型（0 不可退，1 可退款，2 可退货）
			 * @param {*} tradeStatus 
			 */
			async __getCanRefundTypeByJackyunTradeStatus({
				tradeStatus,
				sysFlagIds = "",
				tradeFrom = ""
			}) {
				// 需要隐藏退款按钮的吉客云系统标记：10-虚拟发货、
				let omsTradeSysFlagIdListForHideRefundBtn = ["10"];
				// 配置参数准备
				let paramList = await getParam("canRefundStatusSelect,canReturnTradeStatus,canRefundForVirtualShippingTrade");
				let canRefundStatusSelect = paramList.canRefundStatusSelect || "3";
				// 可以退货的订单状态，默认仅“已完成”可退货
				let canReturnTradeStatus = paramList.canReturnTradeStatus || "9090";
				// “虚拟发货”订单是否允许退款，默认不允许
				if (paramList.canRefundForVirtualShippingTrade == "1") {
					// 从需要隐藏退款按钮的标签中，把“虚拟发货”去掉
					omsTradeSysFlagIdListForHideRefundBtn = omsTradeSysFlagIdListForHideRefundBtn.filter(t => t != "10");
				}

				// 检测oms订单系统标记，存在指定标记的订单则不可退款/退货
				let sysFlagIdList = (sysFlagIds || "").split(',');
				let notAllowedFlagId = sysFlagIdList.find(flagId => omsTradeSysFlagIdListForHideRefundBtn.includes(flagId));
				if (notAllowedFlagId) {
					return 0;
				}

				// 非吉商城订单 不可退款/退货
				if (![4, 11].includes(tradeFrom)) {
					return 0;
				}

				// 仅“已完成”可退货
				if ([9090].includes(tradeStatus)) {
					return 2;
				}

				// 预售未付尾款单子不允许退款
				if ([1030, 5010, 5020, 5030].includes(tradeStatus)) {
					return 0;
				}

				// 可以退货的订单状态，默认仅“已完成”可退货（发货在途订单允许退货，仅小程序要求）
				// let canReturnTradeStatusList = canReturnTradeStatus.split(",");
				// if (canReturnTradeStatusList.includes(tradeStatus.toString())) {
				// 	return 2;
				// }

				let canRefundPaymentStatusOfParam = canRefundStatusSelect;
				// 重新排序 后台设置可能是 "3,1,2"
				canRefundPaymentStatusOfParam = canRefundPaymentStatusOfParam.split(",").sort((a, b) => a - b).join(",");

				let refundPaymentStatus = [];
				switch (canRefundPaymentStatusOfParam) {
					// 待审核
					case "1":
						refundPaymentStatus = [1010];
						break;
						// 待复核
					case "2":
						refundPaymentStatus = [1050];
						break;
					case "1,2":
						refundPaymentStatus = [1010, 1050];
						break;
						// 除发货在途、已完成外的状态
					case "3":
					case "1,2,3":
					case "1,3":
					case "2,3":
						refundPaymentStatus = [6000, 9090];
						break;
						// 不允许发起退款
					case "4":
						refundPaymentStatus = [];
						break;
					default:
						refundPaymentStatus = [];
				}

				if (canRefundPaymentStatusOfParam == "4" || (canRefundPaymentStatusOfParam.includes("3") ? refundPaymentStatus.includes(tradeStatus) : !refundPaymentStatus.includes(tradeStatus))) {
					return 0;
				}

				// 剩余状态均允许退款
				return 1;
			},

			// 获取配置
			async _getParams() {
				// 获取用户信息
				this.customer = await getCustomerInfo();

				// 接收路由参数
				this.tradeNo = this.$route.query.no;

				// 接收配置参数
				let paramList = await getParam("isOpenCannotReturnTime,cannotReturnDays,channelAnotherNameList,isShowSingleSpec,isAllowEditTradeAddress,isShowGoodsNo");
				this.config.isShowSingleSpec = paramList.isShowSingleSpec == "1";
				this.config.isOpenCannotReturnTime = paramList.isOpenCannotReturnTime != "0";
				this.config.cannotReturnDays = parseInt(paramList.cannotReturnDays || "14");
				this.config.channelAnotherNameList = paramList.channelAnotherNameList && JSON.parse(paramList.channelAnotherNameList) || [];
				this.config.isAllowEditTradeAddress = paramList.isAllowEditTradeAddress == "1";
				this.config.isShowGoodsNo = paramList.isShowGoodsNo == "1";
			},
			//获取吉客云物流方式
			async getLogisticsWays() {
				let that = this;
				let paramList = await getParam("bindRefundLogisticList,bindLogisticList");
				var bindRefundLogisticList = !!paramList.bindRefundLogisticList ? JSON.parse(paramList
					.bindRefundLogisticList) : JSON.parse(paramList.bindLogisticList);
				if (bindRefundLogisticList && bindRefundLogisticList.length > 0) {
					var logisticsWays = [];

					bindRefundLogisticList.forEach((item) => {
						let arrLogi = item.split(',');

						logisticsWays.push({
							logisticName: arrLogi.length > 2 ? arrLogi[2] : arrLogi[0],
							logisticId: arrLogi[1]
						});
					});
					that.logisticsWays = logisticsWays;
					that.refundLogistics.logisticName = logisticsWays[0].logisticName;
					that.refundLogistics.logisticId = logisticsWays[0].logisticId;
				}

			},

			onCopySuccess() {
				this.$message({
					message: "复制成功",
					type: 'success'
				});
			},
			onCopyError(e) {
				this.$message.error({
					message: "复制失败"
				});
			},
			goBack() {
				commonUtils.backPage();
			},
			displayTrajectory() {
				this.trajectoryShow = true;
			},

			// differ解密
			decryptDiffer(mobile) {
				let that = this;

				return new Promise(function(resolve, reject) {
					if (!that.checkIsLock(mobile)) {
						resolve(mobile);
						return;
					}
					var items = [];
					items = that.initdecryptJson(items, "phone", mobile);
					var sensitiveOrders = {
						"items": items
					};
					var obj = {
						"encryptModel": "DIFFER"
					};
					obj["sensitiveOrders"] = sensitiveOrders;
					that.$request.jackyunPost({
						method: "trade.decryptdata",
						jsonStr: JSON.stringify(obj)
					}, function(data) {
						if (data.code == 200 && data.result.data.isSuccess == 1) {
							var sensitiveOrders = data.result.data.sensitiveOrders;
							if (sensitiveOrders[0].items[0].isSuccess == 1) {
								resolve(sensitiveOrders[0].items[0].decryptStr);
							}
						}
						resolve(mobile);
					});
				});
			},
			// 校验是否加锁
			checkIsLock(content) {
				let that = this;
				var reg = /.*~\/(\S*)\/~1~~/;
				if (!reg.test(content)) {
					return false;
				}
				return true;
			},

			/**
			 * 解密参数
			 * @param {*} items 
			 * @param {*} type 
			 * @param {*} content 
			 */
			initdecryptJson(items, type, content) {
				var reg = /.*~\/(\S*)\/~1~~/;
				if (reg.test(content)) {
					let plat = content.match(reg)[1];
					if (plat == "differ") {
						var decryContent = {};
						decryContent["type"] = type;
						decryContent["encryptStr"] = content;
						items.push(decryContent);
					}
				}
				return items;
			},

			// 获取吉客云物流信息(非别名)
			async __getLogisticByLogisticId(logisticId, logisticName) {
				if (logisticId == 0) {
					this.logisticName = logisticName;
					return;
				}

				let res = await callFeign("erp.logistic.getbyid", {
					id: logisticId
				});
				if (res.code == 200 && !!res.result.data) {
					logisticName = res.result.data.expressCode || "";
				}
				this.logisticName = logisticName;
			},

			/**
			 * 获取原始单列表
			 * @param {*} sourceTradeNos 
			 */
			async _getOriginalTradeList(sourceTradeNos) {
				// 获取当前页面上已有的原始单列表
				let originalTradeList = this.originalTradeList || [];
				if (originalTradeList.length > 0) {
					return originalTradeList;
				}
				// 获取原始单列表
				originalTradeList = await tradeApi.getJmallTradeDetailList(sourceTradeNos);
				this.originalTradeList = originalTradeList || [];
				return originalTradeList;
			},

			/**
			 * 获取原始单商品集合（并附加一些订单信息到商品上）
			 * @param {*} originalTradeList 
			 */
			_getOriginalTradeGoodsList(originalTradeList = []) {
				// 生成原始单货品列表（多个订单的货品合并到一起）
				let originalTradeGoodsList = [];
				// 遍历原始单，生成原始单货品，并前置计算退货所需数据
				originalTradeList.forEach(originalTrade => {
					// 生成原始单货品列表
					(originalTrade.tradeGoodsList || []).forEach(tradeGoods => {
						tradeGoods.tradeId = originalTrade.tradeId;
						tradeGoods.tradeNo = originalTrade.tradeNo;
						tradeGoods.subTradeNo = `${originalTrade.tradeNo}_${tradeGoods.recId}`;
						tradeGoods.jackyunTradeId = originalTrade.jackyunTradeId;
						tradeGoods.jackyunTradeNo = originalTrade.jackyunTradeNo;
						tradeGoods.couponCode = originalTrade.couponCode; // 卡券编号
						tradeGoods.tradeCouponValue = originalTrade.couponTotal; // 订单上卡券抵扣金额
						tradeGoods.singleGoodsCouponDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.couponDeductionAmount / tradeGoods.sellCount, 4); // 卡券抵扣金额均摊
						tradeGoods.singleGoodsScoreDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.scoreDeductionAmount / tradeGoods.sellCount, 4); // 积分抵扣金额均摊
						tradeGoods.singleGoodsFavourableDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.favourableDeductionAmount / tradeGoods.sellCount, 4); // 改价优惠金额均摊
						tradeGoods.singleGoodsDiscountDeductionAmount = commonUtils.floatKeepDigit(tradeGoods.discountDeductionAmount / tradeGoods.sellCount, 4); // 折扣优惠金额均摊
						tradeGoods.singleGoodsDeductionScore = commonUtils.floatKeepDigit(tradeGoods.sellPrice / originalTrade.goodsTotal * (originalTrade.deductionScore || 0), 4); // 积分抵扣的积分均摊到单个货品
						tradeGoods.shopId = originalTrade.shopId;
						tradeGoods.shopName = originalTrade.shopName;
					});
					originalTradeGoodsList = originalTradeGoodsList.concat(originalTrade.tradeGoodsList);
				});
				return originalTradeGoodsList;
			},

			closeEditDialog() {
				this.createEditDialog = false;
				this.showEditDialog = false;
			},

			async editSuccess(addressInfo) {
				// 获取规格
				let specIds = this.omsTradeInfo.tradeOrderGoodsArr.map(item => item.skuId);

				// 调用限购检测接口，获取检测结果（限购商品+有效商品）
				let res = addressInfo && await tradeApi.checkRestrictedGoods(addressInfo.province, addressInfo.city, addressInfo.district, specIds);

				// 如果校验不通过进行提示
				if (addressInfo && res.restrictedInfoList && res.restrictedInfoList.length > 0) {
					return this.$message.error(res.restrictedInfoList[0].limitSalesReminder);
				}

				// 更新订单详情数据
				this.currentAddr = {
					name: addressInfo.sendTo,
					tel: addressInfo.tel,
					province: addressInfo.province,
					city: addressInfo.city,
					district: addressInfo.district,
					town: addressInfo.town,
					address: addressInfo.address,
					country: addressInfo.country,
					// zipCode: addressInfo.zipCode,
				};

				// 修改订单
				await tradeApi.updateOmsTradeAddressInfo(this.tradeDetail.tradeNo, addressInfo);

				// 更新订单详情数据
				this.tradeReceiver.receiverName = addressInfo.sendTo;
				this.tradeReceiver.mobile = addressInfo.tel;
				this.tradeReceiver.province = addressInfo.province;
				this.tradeReceiver.city = addressInfo.city;
				this.tradeReceiver.district = addressInfo.district;
				this.tradeReceiver.address = addressInfo.address;
				this.tradeReceiver.country = addressInfo.country;

				this.$message.success("修改成功");
				this.closeEditDialog();
			},

			/**
			 * 展示地址修改弹窗
			 */
			openAddressEdit() {
				this.showEditDialog = true;
				this.createEditDialog = true;
			},
		},
	};
</script>

<style scoped="scoped">
	.right-box {
		background-color: #fff;
		padding: 10px 30px 30px 30px !important;
		font-size: 18px;
	}

	.dialogClass .el-dialog__body {
		padding: 20px !important;
		padding-top: 0px !important;
		padding-bottom: 0px !important;
		margin-left: 20px !important;
	}

	.back-box {
		align-items: center;
		margin-left: -20px;
		height: 80px;
	}

	.back-btn {
		font-size: 42px;
		margin-right: 15px;
	}

	.status-box {
		height: 40px;
		background-color: #000;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 24px 20px 24px 30px;
	}

	.trade-status {
		font-weight: bold;
		font-size: 21px;
	}

	.info-box {
		margin: 20px;
		border-bottom: 1px solid #dedede;
		font-size: 16px;
		min-height: 130px;
		position: relative;
	}

	.address-editbtn {
		position: absolute;
		right: 10px;
		bottom: 18px;
		text-align: center;
		font-size: 14px;
		border-radius: 3px;
		width: 60px;
		height: 25px;
		line-height: 25px;
		background-color: black;
		color: white;
		padding: 4px 10px;
		cursor: pointer;
	}

	.small-title {
		font-size: 16px;
		font-weight: 800;
	}

	.base-info {
		margin: 10px;
		line-height: 30px;
	}

	.base-item {
		color: #999;
		width: 80px;
		margin-right: 10px;
		display: inline-block;
		text-align: right;
		flex-shrink: 0;
	}

	.copy-btn {
		padding: 2px 10px;
		font-size: 13px;
		background-color: #F2F2F2;
		margin-left: 10px;
		color: #666;
		cursor: pointer;
	}

	.total-box {
		display: flex;
		justify-content: flex-end;
		border: none !important;
	}

	.total-box /deep/.el-form-item__label,
	.total-box /deep/.el-form-item__content {
		font-size: 17px !important;
		color: #999 !important;
	}

	.total-box /deep/.el-form-item {
		margin-bottom: 0px !important;
	}

	.total {
		color: #000;
		font-size: 18px;
		font-weight: bold;
	}

	.money-text {
		color: #333;
		text-align: right;
		margin-left: 50px;
		line-height: 40px;
	}

	.score-text {
		position: relative;
		bottom: 1px;
		left: 5px;
		font-size: 15px;
	}

	.handle-box {
		margin-bottom: 60px;
		justify-content: flex-end;
	}

	.cancel-btn {
		color: #333;
		background-color: #F2F2F2;
	}

	.handle-btn {
		width: 140px;
		height: 60px;
		font-size: 16px;
		border: none;
		margin-left: 25px !important;
	}

	.log-btn {
		border: 1px solid #fff;
		border-radius: 6px;
		padding: 2px 6px;
		font-size: 15px;
		cursor: pointer;
		width: 100px;
		text-align: center;
	}

	.simple-info {
		margin-right: 20px;
		font-size: 16px;
		align-items: center;
		/* white-space: nowrap; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-all;
		max-width: 500px;
	}

	/deep/ .el-dialog .el-dialog__body {
		display: flex;
		align-items: center;
		margin: 0px !important;
	}

	.number {
		margin-top: 40px;
	}


	.info_footer {
		display: flex;
		display: -webkit-flex;
		line-height: 50px;
	}

	.allCheck {
		margin-left: 14.5px;
	}

	.span_footer {
		margin: 0 50px 0 50px;
	}

	.custom-top {
		height: 100rpx;
		font-size: 100rpx;
		text-align: center;
	}

	.tradeId-top {
		font-size: 80rpx;
		height: 100rpx;
		margin-top: 10px;
		margin-bottom: 5px;
	}

	.refund-button-div {
		text-align: right;
	}

	.el-select {
		width: 300px;
	}

	.el-select-dropdown__item {
		width: 200px !important;
	}

	.detailDialog /deep/ .el-dialog {
		overflow: hidden;
	}

	.dialogBox /deep/ .el-dialog__wrapper {
		overflow: hidden !important;
	}

	.detailDialog /deep/ .el-dialog__body {
		width: 100%;
		padding-right: 0 !important;
		padding-top: 0 !important;
		padding-left: 0 !important;
		overflow-y: auto !important;
	}

	.el-form-item {
		margin-bottom: 8px;
	}

	/deep/ .el-form-item__content {
		line-height: 28px;
	}

	/deep/ .return-goods-box {
		max-height: 500px;
		overflow-y: auto;
	}

	.refund-address {
		border: 1px solid #B1B1B1;
		padding: 10px 20px;
		box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
	}

	.address-title {
		display: flex;
		justify-content: space-between;
		margin-bottom: 15px;
		align-items: center;
	}

	.address-reciver {
		display: flex;
		justify-content: space-between;
		margin-bottom: 5px;
	}

	.reciver-item {
		width: 45%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.address-detail {
		text-overflow: ellipsis;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}

	.radio-group {
		margin-top: 5px;
	}
</style>